import React from "react";
import { SITE, waLink } from "@/lib/site";
import { MessageCircle } from "lucide-react";

const FloatingWhatsApp = () => {
  return (
    <a
      data-testid="floating-wa"
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`WhatsApp ${SITE.whatsappDisplay}`}
      className="fixed bottom-5 right-5 z-40 bg-[#25D366] hover:bg-[#1FB955] text-black w-14 h-14 rounded-full flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.35)] transition-transform hover:-translate-y-0.5"
    >
      <MessageCircle className="w-7 h-7" strokeWidth={2.2} />
    </a>
  );
};

export default FloatingWhatsApp;
